import axios from '@axios';
import jwtConfig from './jwtConfig';
import { myJwtService } from './myJwtService';

const jwtService = new myJwtService(axios, jwtConfig);
export default jwtService;
